export default __webpack_public_path__ + "static/media/Apotheosis of Hate.d8d2fb3b.jpg";